module.exports = __webpack_public_path__ + "static/img/img_logo_zhunya.b602b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_logo_zhunya.png
// module id = 5QTU
// module chunks = 1